import type { ReactNode } from 'react';
import { QueryProvider } from './QueryProvider';
import { AuthProvider } from './AuthProvider';
import { FeedbackProvider } from './FeedbackProvider';
import { NavigationProvider } from '@/shared/navigation';

interface AppProvidersProps {
  children: ReactNode;
}

/**
 * Zapouzdření všech globálních providerů aplikace.
 * Pořadí je důležité - vnější providery mohou být využívány vnitřními.
 * Skládá pouze veřejná API slice – žádný slice-specifický obsah.
 */
export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <AuthProvider>
        <NavigationProvider>
          <FeedbackProvider>{children}</FeedbackProvider>
        </NavigationProvider>
      </AuthProvider>
    </QueryProvider>
  );
}
